<template>
    <div class="common-box">
        
         <div class="common-header">   
            <img :src="backSrc"  class="back-img" @click="back"/>
            宣教详情
        </div>
        
        <div class="common-content-box">
                
            <div class="p-content-box">
                <div class="title" v-html="data.edu_content">  </div>
                <ul class="intro-box">
                    <li> 患者：{{data.patientInfo.xingming}}  {{data.patientInfo.xingbie}}  {{data.patientInfo.nianling}} </li>
                    <li v-if="data.edu_object"> 教育对象：{{data.edu_object}} </li>
                    <li v-if="data.edu_opporunity"> 教育时机：{{data.edu_opporunity}} </li>
                    <li v-if="data.edu_project"> 教育项目：{{data.edu_project}} </li>
                </ul>
                <div class="content-box" v-html="data.edu_detail_sub" id="index-content-box">
                </div>
            </div>


            <div class="time-box" v-if="time"> ({{time}}S) 我已知晓  </div>
            <div class="know-box" v-if="!time" @click="knowClick"> 我已知晓  </div>        

            <div class="qianming-box" ref="qianmingBox"> 
                <div class="con-box">
                    <div class="tit"> 
                        签名 
                        
                        <img :src="closeImg" @click="close" />
                    </div>
                    <div class="guanxi">
                        <span> 被宣教人： </span>    
                        <select v-model="edu_object">
                            <option value="病人">病人</option>
                            <option value="家属">家属</option>
                        </select>
                    </div>
                    
                    <div class="qianming"> 请在下方签名  </div>
                    <div class="canvas-box" id="signature" ref="canvasHW">
                        <canvas
                            @touchstart="touchStart"
                            @touchmove="touchMove"
                            @touchend="touchEnd"
                            ref="canvasF"
                            @mousedown="mouseDown"
                            @mousemove="mouseMove"
                            @mouseup="mouseUp"
                          ></canvas>
                    </div>
                    <div class='button-box'>
                        
                        <div class="cancel-button" @click="overwrite">重签</div>
                        <div class="save-button" @click="submitClick">保存签名</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    
    import { getInfoById , addQianming } from '@/service/getData'
    import { Toast } from 'vant';

    export default {
        name: "index",
        components: {
          
        },
        data: function () {
            return {
                backSrc:require("@/assets/image/back.png"),
                closeImg:require("@/assets/image/close.png"),
                time:3,
                points: [],
                canvasTxt: null,
                startX: 0,
                startY: 0,
                moveY: 0,
                moveX: 0,
                endY: 0,
                endX: 0,
                w: null,
                h: null,
                isDown: false,
                color: "#000",
                linewidth: 3,
                isDraw: false, //签名标记
                stageInfo:'',
                inter:"",
                show:false,
                data:{
                    edu_content:"",
                    edu_project:"",//宣教内容
                    edu_object:"", //教育对象
                    edu_opporunity:"" , //教育时机
                    edu_project:"" , // 教育项目
                    edu_detail_sub:"" , //子内容
                    patientInfo:{
                        xingming:"",
                        xingbie:"",
                        nianling:"",
                        zhenduan:""
                    }
                },
                edu_object:"病人"
            };
        },
        beforeMount: function () {
            
        },
        mounted: function () {

            let xuanjiao_id = this.$route.query.xuanjiao_id;
            let yiyuan_id = this.$route.query.yiyuan_id;
            let open_id = this.$route.query.open_id;
            

            getInfoById(xuanjiao_id , yiyuan_id).then(res => {

                this.data = res.data;
                
                if(this.data.edu_status == '已宣教'){
                    this.$router.push({
                            path: "/detail",
                            query:{
                                'xuanjiao_id':xuanjiao_id,
                                'yiyuan_id':yiyuan_id,
                                'open_id':open_id
                            }
                        });
                }

                var divObj = document.createElement('div');
                divObj.innerHTML = this.data.edu_detail_sub;

                var imgs = divObj.getElementsByTagName('img');

                for(var i = 0 ; i < imgs.length ; i++){

                    imgs[i].style.width = "90%";
                    imgs[i].style.height = "auto";
                    imgs[i].width = "";
                    imgs[i].height = "";
                }


                var videos = divObj.getElementsByTagName('video');

                for(var i = 0 ; i < videos.length ; i++){

                    videos[i].style.width = "90%";
                    videos[i].style.height = "auto";
                    videos[i].width = "";
                    videos[i].height = "";
                }

                this.data.edu_detail_sub = divObj.innerHTML;

                /*
                if(res.code == 200){    

                }else{
                    Toast(res.msg);
                }*/

            });

            this.inter = setInterval( this.setTime , 1000);
        },
        updated: function () {

        },
        methods: {
           
            mouseDown(ev) {
                ev = ev || event;
                ev.preventDefault();

                let obj = {
                    x: ev.offsetX,
                    y: ev.offsetY
                };
                this.startX = obj.x;
                this.startY = obj.y;
                this.canvasTxt.beginPath();//开始作画
                this.points.push(obj);//记录点
                this.isDown = true;
            },

            touchStart(ev) {

                ev = ev || event;

                if( ev.cancelable) {
                    ev.preventDefault();
                }

                if (ev.touches.length == 1) {
                    
                    this.isDraw = true; //签名标记
                    let obj = {
                        x: ev.targetTouches[0].clientX - this.stageInfo.left,
                        y: ev.targetTouches[0].clientY - this.stageInfo.top
                    }

                    this.startX = obj.x ;
                    this.startY = obj.y ;
                    this.canvasTxt.beginPath();//开始作画
                    this.points.push(obj);//记录点
                }
            },

            mouseMove(ev) {
                ev = ev || event;
                ev.preventDefault();
                if (this.isDown) {
                    let obj = {
                        x: ev.offsetX,
                        y: ev.offsetY
                    };
                    this.moveY = obj.y;
                    this.moveX = obj.x;
                    this.canvasTxt.moveTo(this.startX, this.startY);//移动画笔
                    this.canvasTxt.lineTo(obj.x, obj.y);//创建线条
                    this.canvasTxt.stroke();//画线
                    this.startY = obj.y;
                    this.startX = obj.x;
                    this.points.push(obj);//记录点
                }
            },

            touchMove(ev) {

                ev = ev || event;
                ev.preventDefault();
                if (ev.touches.length == 1) {

                    let obj = {
                        x: ev.targetTouches[0].clientX - this.stageInfo.left,
                        y: ev.targetTouches[0].clientY - this.stageInfo.top
                    }

                    this.moveY = obj.y ;
                    this.moveX = obj.x ;
                    this.canvasTxt.moveTo(this.startX, this.startY);//移动画笔
                    this.canvasTxt.lineTo(obj.x, obj.y);//创建线条
                    this.canvasTxt.stroke();//画线
                    this.startY = obj.y;
                    this.startX = obj.x;
                    this.points.push(obj);//记录点
                }
            },

            mouseUp(ev) {

                ev = ev || event;
                ev.preventDefault();
                if (1) {
                    let obj = {
                        x: ev.offsetX,
                        y: ev.offsetY
                    };

                    this.canvasTxt.closePath();//收笔
                    this.points.push(obj);//记录点
                    this.points.push({ x: -1, y: -1 });
                    this.isDown = false;
                }
            },

            touchEnd(ev) {
                ev = ev || event;
                ev.preventDefault();
                if (ev.touches.length == 1) {
                    let obj = {
                        x: ev.targetTouches[0].clientX - this.stageInfo.left,
                        y: ev.targetTouches[0].clientY - this.stageInfo.top
                    }
                    this.canvasTxt.closePath();//收笔
                    this.points.push(obj);//记录点
                    this.points.push({ x: -1, y: -1 });//记录点
                }
            },

            overwrite() {
                this.canvasTxt.clearRect(
                    0,
                    0,
                    this.$refs.canvasF.width,
                    this.$refs.canvasF.height
                );
                this.points = [];
                this.isDraw = false; //签名标记
            },

            setTime(){

                this.time = this.time - 1;
                if(this.time == 0){

                    clearInterval(this.inter);
                }
            },

            knowClick(){

                this.$refs.qianmingBox.style.display = "block";

                let canvas = this.$refs.canvasF;
                canvas.height = this.$refs.canvasHW.offsetHeight;
                canvas.width = this.$refs.canvasHW.offsetWidth;
                this.canvasTxt = canvas.getContext("2d");
                this.canvasTxt.strokeStyle = this.color;
                this.canvasTxt.lineWidth = this.linewidth;
                this.stageInfo = canvas.getBoundingClientRect();  //getBoundingClientRect()可以不用考虑兼容性
            },

            close(){

                this.$refs.qianmingBox.style.display = "none";
                this.overwrite();
            },

            clickCon(ev){

                ev.preventDefault();
            },

            submitClick(){

                let canvas = this.$refs.canvasF;
                let data = canvas.toDataURL();

                let xuanjiao_id = this.$route.query.xuanjiao_id;
                let yiyuan_id = this.$route.query.yiyuan_id;
                let open_id = this.$route.query.open_id;
                

                addQianming(xuanjiao_id , data , this.edu_object , yiyuan_id).then(res => {

                    if(res.code == 200){    

                        this.$router.push({
                            path: "/list",
                            query:{
                                'open_id':open_id
                            }
                        });
                    }else{
                        Toast(res.msg);
                    }
                });

            },
            back(){

                let open_id = this.$route.query.open_id;

                this.$router.push({
                    path: "/list",
                    query:{
                        'open_id':open_id
                    }
                });
           }
        }
    };
</script>

<style lang="scss" scoped>
    @import "./style/index.scss";
</style>

<style type="text/css">
</style>

